import bem from 'utils/bem';

export const block = bem('cta-buttons-modal-contents');
